// componente che contiene tutti i metodi utilizzati per gestire i pannelli; queste funzioni sono richiamate esternamente
// dalle altre componenti che costituiscono tutto il blocco di gestione pannelli (scheduler-edit e scheduler-list)

import { Injectable } from '@angular/core';
import { Scheduler } from './scheduler.model';
import { Subject } from 'rxjs';


@Injectable()
export class SchedulerService {
  private scheduler: Scheduler[] = [];
  schedulerChanged = new Subject<Scheduler[]>();
  schedulerEditMode = new Subject<number>();
  groupid
  groupids
  public refresh = new Subject<any>();
  refresh$ = this.refresh.asObservable();
  constructor(
  ) { }
  viewDate

  setGroupids(groupids) {
    this.groupids = groupids;
  }
  getGroupids() {
    return this.groupids;
  }
  // metodo richiamato alla modifica di un pannello; viene identificata la posizione nella tabella dell'elemento da aggiornare
  editScheduler(scheduler) {
    this.schedulerEditMode.next(scheduler.ID);
  }
  updateSchedules() {
    this.refresh.next();
  }

  // metodo richiamato all'inserimento di un nuovo pannello; viene identificata la posizione nella tabella dell'elemento da aggiungere
  setScheduler(scheduler: Scheduler[]) {
    if (scheduler !== null) {
      this.scheduler = scheduler;
      this.schedulerChanged.next(this.scheduler.slice());
    }
  }

  // metodo che restituisce l'intero oggetto "pannello" in base alla posizione nella tabella
  getSchedulerByIndex(id: number) {
    return this.scheduler.find(x => x.id === id);
  }

  // metodo che restituisce tutti i pannelli memorizzati localmente
  getScheduler() {
    return this.scheduler;
  }
  // metodo che restituisce tutti i pannelli memorizzati localmente
  setviewDate(viewDate) {
    this.viewDate = viewDate;
  }
  // metodo che restituisce tutti i pannelli memorizzati localmente
  getviewDate() {
    return this.viewDate;
  }

  // metodo che restituisce tutti i pannelli memorizzati localmente
  getGroupid() {
    return this.groupid;
  }
  // metodo che restituisce tutti i pannelli memorizzati localmente
  setGroupid(groupid) {
    this.groupid = groupid;
  }

  // metodo che inserisce il nuovo pannello appena inserito nell'array locale contenente tutti i pannelli, aggiornando la tabella
  addScheduler(scheduler: Scheduler) {
    scheduler.id = this.scheduler.length;
    this.scheduler.push(scheduler);
    this.schedulerChanged.next(this.scheduler.slice());
  }

  // metodo che aggiorna il pannello appena modificato nell'array locale contenente tutti i pannelli, aggiornando la tabella
  updateScheduler(index: number, scheduler: Scheduler) {
    this.scheduler[index] = scheduler;
    this.schedulerChanged.next(this.scheduler.slice());
  }

  // metodo che individua la posizione del pannello appena cancellato, aggiorna la tabella e l'array locale contenente tutti i pannelli
  deleteScheduler(id) {
    var elementPos = this.scheduler.map(function (x) { return x.id; }).indexOf(id);
    this.scheduler.splice(elementPos, 1);
    this.schedulerChanged.next(this.scheduler.slice());
  }
}
